import { faEllipsis } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popover, PopoverTrigger } from "../../../../components";
import { LeadButton, type LeadButtonProps } from "./LeadButton";
import { LeadMenu } from "./menu";
import { UserProfile } from "../../../../client";

interface Props extends LeadButtonProps {
  onArchive: () => void;
  onDelete?: () => void;
  leadId?: string;
  profileLinkId?: string;
  archived?: boolean;
  profiles: UserProfile[];
  profileId?: string;
}

export const LeadMenuButton = ({
  onArchive,
  onDelete,
  leadId,
  profileLinkId,
  archived,
  profiles,
  profileId,
  ...props
}: Props) => (
  <Popover>
    <PopoverTrigger asChild>
      <LeadButton {...props}>
        <FontAwesomeIcon
          width={20}
          height={20}
          icon={faEllipsis}
          className="w-5 h-5 shrink-0"
        />
      </LeadButton>
    </PopoverTrigger>
    <LeadMenu
      onArchive={onArchive}
      profileLinkId={profileLinkId}
      archived={archived}
      onDelete={onDelete}
      leadId={leadId}
      profiles={profiles}
      profileId={profileId}
    />
  </Popover>
);
